import { RowCrudStatus } from "../../common/types";
import {
  EsignatureConfig,
  EsignatureConfigCreateMutationVariables,
  EsignatureConfigUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { EsignatureProvider } from "../../../api/graphql";
import { safeJsonParse } from "../../../common/utils";
import { blankToNull } from "../../../common/blankToNull";

export type EsignatureConfigValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  provider: EsignatureProvider;
  credentials: string;
  sandboxMode: boolean;
  webhookSecret: string;
  enabled: boolean;
};

export type EsignatureConfigErrorsType = {
  provider?: { message: string; fieldLabel: string };
  credentials?: { message: string; fieldLabel: string };
  sandboxMode?: { message: string; fieldLabel: string };
  webhookSecret?: { message: string; fieldLabel: string };
  enabled?: { message: string; fieldLabel: string };
};

export function EsignatureConfigValuesInit(): EsignatureConfigValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    provider: "" as EsignatureProvider,
    credentials: "{}",
    sandboxMode: false,
    webhookSecret: "",
    enabled: false,
  };
}

export type EsignatureConfigType =
  | EsignatureConfig
  | EsignatureConfigValuesType;

export function esignatureConfigDisplayId(
  source: Partial<EsignatureConfig>,
  _langStore: LangStore
) {
  return source.provider ?? _langStore.emptyStringSymbol;
}

export function getEsignatureConfigValues(
  source: EsignatureConfigType,
  _langStore: LangStore,
  _duplicated: boolean = false
): EsignatureConfigValuesType {
  const entityValues = EsignatureConfigValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : esignatureConfigDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.provider = source.provider;
  entityValues.credentials = source.credentials;
  entityValues.sandboxMode = source.sandboxMode || false;
  entityValues.webhookSecret = source.webhookSecret || "";
  entityValues.enabled = source.enabled || false;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getEsignatureConfigUpdateVariables(
  values: EsignatureConfigValuesType
): EsignatureConfigUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    provider: values.provider,
    credentials: safeJsonParse(values.credentials, "credentials"),
    sandboxMode: values.sandboxMode,
    webhookSecret: blankToNull(values.webhookSecret),
    enabled: values.enabled,
  };
}

export function getEsignatureConfigCreateVariables(
  values: EsignatureConfigValuesType
): EsignatureConfigCreateMutationVariables {
  return {
    provider: values.provider,
    credentials: safeJsonParse(values.credentials, "credentials"),
    sandboxMode: values.sandboxMode,
    webhookSecret: blankToNull(values.webhookSecret),
    enabled: values.enabled,
  };
}
